/**
 * Override console methods in production to prevent logs from appearing
 * This is imported in main.ts before bootstrapping the application
 */

import { environment } from '@env/environment';

export function overrideConsoleInProduction(): void {
  if (environment.production) {
    // Save original methods for error and warn
    const originalError = console.error;
    const originalWarn = console.warn;

    // Override console methods
    console.log = () => {};
    console.debug = () => {};
    console.info = () => {};

    // Keep error and warn for debugging production issues
    console.error = originalError;
    console.warn = originalWarn;

    // Optional: Override other console methods
    console.trace = () => {};
    console.group = () => {};
    console.groupEnd = () => {};
    console.groupCollapsed = () => {};
    console.table = () => {};
    console.time = () => {};
    console.timeEnd = () => {};
    console.timeLog = () => {};
    console.count = () => {};
    console.countReset = () => {};
    console.dir = () => {};
    console.dirxml = () => {};
    // console.profile = () => {};
    // console.profileEnd = () => {};
  }
}
